import IUser from '../interfaces/IUser'
import IApiResponse from '../interfaces/IApiResponse';
import IApiMessage from '../interfaces/IApiMessage';
import ApiEndPoints from '../data/ApiEndPoints';

let loggedOutUser:IUser = { 
    id: '0',
    username: '',
    password: '',
    token: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: null,
    role: null,
}

let FailedMessage:IApiMessage = {
    ServerMessage: 'ERROR: 400',
    UserMessage: 'Login Failed'
}

const localStorageUserKey = 'currentUser';

export const  AccountLogin = async (user:IUser):Promise<IApiResponse<IUser>> => {
    let loggedIn = false;

    let mockUser:IUser = loggedOutUser;
    let mockMessage:IApiMessage = FailedMessage;

    const loginRequest = {
        "username": user.username,
        "password": user.password
      };

    const fetchPromise:Promise<IApiResponse<IUser>> = fetch(ApiEndPoints.UserLogin, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginRequest),
        }).then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);

            const loggedInUser:IUser = { 
                id: data.user.id,
                username: data.user.userName,
                password: '',
                token: data.token,
                firstName: data.user.firstName,
                lastName: data.user.lastName,
                email: data.user.email,
                phone: data.user.phoneNumber,
                addressLine1: data.user.addressLine1,
                addressLine2: data.user.addressLine2,
                city: data.user.city,
                state: data.user.state,
                zipCode: data.user.zipCode,
                role: data.roles[0]
            }

            const SuccessMessage: IApiMessage = {
                ServerMessage: 'SUCCESS: 200',
                UserMessage: 'Login Successful'
            }
    
            //Store in local storage to persist user between sessions
            localStorage.setItem(localStorageUserKey, JSON.stringify(loggedInUser));
            
            return { Data: loggedInUser, Success: true, Message: SuccessMessage }
        })
        .catch((error) => {
            console.error('Error:', error);
            console.log(error)
            if(error.message.includes('Unauthorized')) {
                mockMessage = {
                    ServerMessage: 'FAILED: 401',
                    UserMessage: 'Login Not Found'
                }
            }
            return { Data: mockUser, Success: loggedIn, Message: mockMessage };
        })

    return fetchPromise;
}

//if we need to make fetch call to log out change IApiResponse to Promise<IApiResponse> and return the fetch promise from the application
export const AccountLogout = ():IApiResponse<IUser> => {

    const successMessage = {
        ServerMessage: 'SUCCESS: 200',
        UserMessage: 'User Successfully Logged Out'
    }

    let response: IApiResponse<IUser> = { Data: loggedOutUser, Message: successMessage, Success: true }

    //Store in local storage to persist user between sessions
    localStorage.removeItem(localStorageUserKey)
    
    return response;
}

export const GetUserFromLocalStorage = () => {

    const currentLocalStoreUser = localStorage.getItem(localStorageUserKey);
    if(currentLocalStoreUser) {
        return JSON.parse(currentLocalStoreUser);
    }
    else {
        return loggedOutUser;
    }
}

export const AccountUpdate = async (user:IUser):Promise<IApiResponse<IUser>> => {

    const fetchPromise:Promise<IApiResponse<IUser>> = fetch(`${ApiEndPoints.UpdateUser}/${user.id}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.token}`
        },
        body: JSON.stringify(user),
        }).then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .then(response => {
            console.log('Success:', response);

            const successMessage = {
                ServerMessage: 'SUCCESS: 200',
                UserMessage: 'User Successfully Updated'
            }
                
            //Store in local storage to persist user between sessions
            localStorage.setItem(localStorageUserKey, JSON.stringify(user));
            
            return { Data: user, Success: true, Message: successMessage }
        })
        .catch((error) => {
            console.error('Error:', error);
            let responseMessage = {
                ServerMessage: 'error',
                UserMessage: 'An Error Ocurred while updating user.'
            }
            if(error.message.includes('Unauthorized')) {
                responseMessage = {
                    ServerMessage: 'FAILED: 401',
                    UserMessage: 'Unauthorized to update user profile.'
                }
            }
            return { Success: false, Message: responseMessage };
        })

    return fetchPromise;
}

export default AccountLogin;